import styled from 'styled-components';

import { variableFontRegular } from 'styles/theme';

export interface IWindowItemLongTextProps {
  text: string;
}

export const WindowItemLongText = ({ text }: IWindowItemLongTextProps) => {
  return (
    <WindowItemLongText.Wrapper>
      <WindowItemLongText.Text>{text}</WindowItemLongText.Text>
    </WindowItemLongText.Wrapper>
  );
};

WindowItemLongText.Wrapper = styled.div`
  border-bottom: ${({ theme }) => theme.borders.black};
  padding: 16px;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.small - 1}px) {
    ${variableFontRegular({ height: '16px', size: '11.5px' })}
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.small}px) {
    ${variableFontRegular({ height: '16px', size: '11.5px' })}
  }
`;

WindowItemLongText.Text = styled.p`
  display: block;
  margin-block-start: 0;
  margin-block-end: 0;
  margin-inline-start: 0;
  margin-inline-end: 0;
  min-height: 'fit-content';
  white-space: break-spaces;
`;
